import { render, staticRenderFns } from "./DistroCenters.vue?vue&type=template&id=d3f558ec&scoped=true"
import script from "./DistroCenters.vue?vue&type=script&lang=js"
export * from "./DistroCenters.vue?vue&type=script&lang=js"
import style0 from "./DistroCenters.vue?vue&type=style&index=0&id=d3f558ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f558ec",
  null
  
)

export default component.exports